/**
 * QuotaPill — пилюля с остатком дневной квоты ("Сегодня: 3/50").
 *
 * Цвет автоматически:
 *   - off       (enabled=false)         → серый "Недоступен"
 *   - danger    (used >= limit)         → красный
 *   - warning   (used >= 80% limit)     → янтарный
 *   - default                           → акцент
 *
 * Используется внутри ConversationHeader как `subtitle={<QuotaPill .../>}`.
 */

export default function QuotaPill({ used, limit, enabled = true }) {
    if (!enabled) {
        return (
            <span className="conversation__quota conversation__quota--off">
                Сервис недоступен
            </span>
        )
    }
    if (limit == null || used == null) return null

    const pct = limit > 0 ? used / limit : 0
    let toneClass = ''
    if (used >= limit) toneClass = 'conversation__quota--danger'
    else if (pct >= 0.8) toneClass = 'conversation__quota--warning'

    return (
        <span className={`conversation__quota ${toneClass}`.trim()}>
            Сегодня: {used}/{limit}
        </span>
    )
}
